import zod from 'zod';
import { stringToBoolean, stringToListOfEnum, stringToListOfNumber, zodLimit, zodPage } from './helpers';
import { attachmentTypes, occurrencePriorities, occurrenceSituations, triggerTypes } from './dispatch';

export const PeriodType = [
    'lastHour',
    'last12Hour',
    'last24Hours',
    'today',
    'weekly',
    'fortnightly',
    'monthly',
    'semiannual',
    'annual',
    'allPeriod'
    , 'select'
] as const;
export const PlateMonitoringDashboardSelectedTab = ['plateGroupsManagement', 'registeredPlates', 'dashboard', ''] as const;

const DashboardOccurrencesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    triggerTypeIds: stringToListOfEnum(zod.enum([
        ...triggerTypes,
        'manual',
    ])).optional(),
    priority: zod.enum(occurrencePriorities).optional(),
    situation: zod.enum(occurrenceSituations).optional(),
    occurrenceTypeId: stringToListOfNumber.optional(),
    responsibleUserId: zod.coerce.number().optional(),
    unitNamesIds: stringToListOfNumber.optional(),
    textFilter: zod.string().optional(),
    tags: stringToListOfNumber.optional(),
    actingBodyId: zod.coerce.number().optional(),
    mapPolygonIds: stringToListOfNumber.optional(),
    polygonType: zod.string().optional(),
    assumedBy: zod.coerce.number().optional(),
    transferredBy: zod.coerce.number().optional(),
    receivedBy: zod.coerce.number().optional(),
    finishedBy: zod.coerce.number().optional(),
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
    actingBodyCommandIds: stringToListOfNumber.optional(),
    withDispatch: stringToBoolean.optional(),
    withoutDispatch: stringToBoolean.optional(),
    withOccurrenceDocument: stringToBoolean.optional(),
    withoutOccurrenceDocument: stringToBoolean.optional(),
    latitude: zod.coerce.number().optional(),
    longitude: zod.coerce.number().optional(),
    radius: zod.coerce.number().optional(),
    displaceReasonIds: stringToListOfNumber.optional(),
    finishReasonCategoryIds: stringToListOfNumber.optional(),
    finishReasonSubCategoryIds: stringToListOfNumber.optional(),
    actingBodyUnitIds: stringToListOfNumber.optional(),
    policeReport: zod.string().optional(),
    cameraTags: stringToListOfNumber.optional(),
    attachmentTypes: zod.array(zod.enum(attachmentTypes)).optional(),
    involvedPersonSearch: zod.string().optional(),
    handcuffUsed: stringToBoolean.optional(),
    arrested: stringToBoolean.optional(),
});

const DashboardAgentsSchema = zod.object({
    textFilter: zod.string().optional(),
    actingBodyUnitId: zod.coerce.number().optional(),
    actingBodyId: zod.coerce.number().optional(),
    phone: zod.string().optional(),
    offline: stringToBoolean.optional(),
    online: stringToBoolean.optional(),
    unitIds: stringToListOfNumber.optional(),
});

const DashboardVehiclesSchema = zod.object({
    textFilter: zod.string().optional(),
    actingBodyUnitId: zod.coerce.number().optional(),
    actingBodyId: zod.coerce.number().optional(),
    actingBodyCommandIds: stringToListOfNumber.optional(),
    categoryListIds: stringToListOfNumber.optional(),
});

const DashboardPlateMonitoringSchema = zod.object({
    groupId: zod.coerce.number().optional(),
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
    fixedPeriod: zod.enum(PeriodType).optional(),
    selectedTab: zod.enum(PlateMonitoringDashboardSelectedTab).optional(),
});

export const DashboardSchemas = {
    DashboardCameras: zod.object({}),
    DashboardAgents: DashboardAgentsSchema,
    DashboardOccurrences: DashboardOccurrencesSchema,
    DashboardVehicles: DashboardVehiclesSchema,
    DashboardPlateMonitoring: DashboardPlateMonitoringSchema,
};
